import styled from 'styled-components';

const StyledPreviewText = styled.div<{ isScaled: boolean; color: string }>`
  background-color: ${(props) => props.color};
  color: white;
  font-size: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 50%;
  transform: ${(props) => props.isScaled && `scale(0.9)`};
`;

const StyledPreviewImg = styled.img<{ isScaled: boolean; color: string }>`
  z-index: 1;
  border: ${(props) => (props.isScaled ? '' : `2px solid ${props.color}`)};
  background-size: cover;
  transform: ${(props) => props.isScaled && `scale(0.9)`};
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 50%;
`;

const StyledBubbleWrapper = styled.div`
  color: white;
  text-align: center;
  font-size: 50%;
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 50%;
`;

const StyledBubbleContainer = styled.div`
  position: relative;
  width: 74%;
  top: 57%;
  left: 13%;
`;

const StyledBubble = styled.div`
  z-index: 2;
  width: 49%;
  padding-top: 49%;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  background-color: ${(props) => props.color};
`;

const StyledBubbleContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

const StyledSlicesWrapper = styled.div`
  overflow: hidden;
  position: absolute;
  border-radius: 50%;
  background-size: cover;
  border: 1px solid rgba(205, 205, 205, 0.7);
  cursor: pointer;
  transition: all 0.4s;
  width: 100%;
  height: 100%;
`;

const StyledBubbleSlice = styled.div<{
  rotate: number;
  skew: number;
  color: string;
}>`
  width: 100%;
  height: 100%;
  transform-origin: top left;
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: ${(props) => props.color};
  transform: ${(props) => `rotate(${props.rotate}deg) skew(${props.skew}deg)`};
`;
export {
  StyledPreviewText,
  StyledPreviewImg,
  StyledBubbleWrapper,
  StyledBubbleContainer,
  StyledBubbleContent,
  StyledBubble,
  StyledBubbleSlice,
  StyledSlicesWrapper
};
